import { Box, Link, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomIconButton from '../../../../components/CustomIconButton';
import { ReactComponent as BackArrowIcon } from "../../../../assets/images/ralvie/back-arrow-icon.svg";
import AppContext from '../../../../config/AppContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Typewriter from '../../../../components/Typewriter';
import { Divider } from 'antd';
import CopyAndExport from './CopyAndExport';


export default function SelectedSummary({ setIsDateSelected, selectedSummaries }) {

    const { mode } = useContext(AppContext);
    const { t } = useTranslation();
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const [isTypewriterActive, setIsTypewriterActive] = useState(false);

    const handleTypewriterStart = () => {
        setIsTypewriterActive(true);
    };

    const handleTypewriterEnd = () => {
        setIsTypewriterActive(false);
    };

    useEffect(() => {
        // console.log(" ----- ", selectedSummaries.id);
    }, [selectedSummaries])

    function processTextSummary(text) {
        const summary = text?.replace(/\"/g, "").trim(); // Clean up the summary text
        const startIndex = summary.indexOf("Projects:");
        const cleanSummary = summary.substring(startIndex).trim();
        const lines = cleanSummary.split("\n"); // Split the summary into lines

        let htmlSummary = '<div class="summary">';
        lines.forEach((line) => {
            if (line.includes(":")) {
                const [label, content] = line.split(":", 2);
                htmlSummary += `<p><strong>${label.trim()}:</strong> ${content.trim()}</p>`;
            } else {
                htmlSummary += `<p>${line.trim()}</p>`;
            }
        });
        htmlSummary += "</div>";
        return htmlSummary;
    }

    return (
        <Box p={1}>
            <Box display="flex"
                justifyContent={'flex-start'}>
                <Box>
                    <Link
                    className={mode === "dark"? 'back-summary-agentDark':'back-summary-agent'}
                        component={'button'}
                        
                        onClick={() => {
                            setIsDateSelected(false);
                            selectedSummaries([]);
                        }}
                    >
                        {t('RAL1205')}
                    </Link>
                </Box>
            </Box>

            <Box>
                {(selectedSummaries && selectedSummaries.length > 0) &&
                    selectedSummaries.map((item, index) => {
                        return <Box
                            className={mode === "dark" ? "type-writer-space1-dark" : "type-writer-space1"}
                        >
                            <Box
                                dangerouslySetInnerHTML={{ __html: processTextSummary(item.summary) }}
                            />
                            <CopyAndExport textToCopy={item.summary} />
                            <Divider />
                        </Box>;
                    })
                }
            </Box>

        </Box>
    )
}
